function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 20c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8zm5.116-3.287a3.087 3.087 0 00-3.051-2.648c-.662 0-.981.367-2.065.367s-1.4-.367-2.065-.367a3.087 3.087 0 00-3.051 2.648A6.93 6.93 0 015.032 12 6.976 6.976 0 0112 5.032 6.976 6.976 0 0118.968 12a6.93 6.93 0 01-1.852 4.713zM12 13.29a2.839 2.839 0 100-5.677 2.839 2.839 0 000 5.677z",
  fill: "#212121",
  fillOpacity: 0.6
});

function SvgAtomsIconUserSolidinline(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgAtomsIconUserSolidinline;